import { Fragment, useEffect } from 'react';
import Head from 'next/head';
import { useWistiaScript } from './WistiaVideo.context';

export type Props = {
  wistiaId: string;
};

export const WistiaVideo = ({ wistiaId }: Props) => {
  const { setIsWistiaOnThePage } = useWistiaScript();

  useEffect(() => {
    setIsWistiaOnThePage();
  }, [setIsWistiaOnThePage]);

  return (
    <Fragment>
      <Head>
        <script
          defer={true}
          src={`https://fast.wistia.com/embed/medias/${wistiaId}.jsonp`}
        />
      </Head>
      <div className="wistia_responsive_wrapper">
        <div className="wistia_responsive_padding">
          <span
            className={`wistia_embed wistia_async_${wistiaId} videoFoam=true`}
            style={{
              display: 'inline-block',
              height: '100%',
              position: 'relative',
              width: '100%',
            }}
          />
        </div>
      </div>
    </Fragment>
  );
};
